import axios from 'axios';
import StaticVar from 'config/StaticVar';

export const generateSSOToken = async () => {
  try {
    // Call your backend to create a short-lived SSO token
    const response = await axios.post(`${StaticVar.URL_API}/auth/sso-token`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    });
    return response.data.ssoToken;
  } catch (error) {
    console.error("Error generating SSO token:", error);
    throw error;
  }
};